import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PageModel } from 'src/app/Models/page-model';

@Component({
  selector: 'ze-add-page',
  templateUrl: './add-page.component.html',
  styleUrls: ['./add-page.component.scss']
})
export class AddPageComponent implements OnInit {
  newWP: PageModel;
  title = "Create New"
  deleted = { deleted: true }
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AddPageComponent>) {
    this.newWP = new PageModel();
    data == null ? this.newWP = new PageModel() : this.newWP = JSON.parse(JSON.stringify(data.webPage));
    if (Object.keys(this.newWP).length != 0) {
      this.title = "Edit"
    }
  }
  ngOnInit() {
  }
  onCloseClick(): void {
    this.dialogRef.close();
  }
}
